module.exports = __webpack_public_path__ + "img/hopter.5e12ccae.svg";